document.addEventListener('DOMContentLoaded', function() {
    const specItems = document.querySelectorAll('.spec-item');
    const specContents = document.querySelectorAll('.spec-content');

    specItems.forEach(item => {
      item.addEventListener('click', () => {
        const targetId = item.dataset.target;
        const targetContent = document.getElementById(targetId);

        if (targetContent) {
          // Remove 'selected_list_item' class from all other items
          specItems.forEach(otherItem => {
            if (otherItem !== item) {
              otherItem.classList.remove('selected_list_item');
            }
          });

          // Hide all other spec contents
          specContents.forEach(content => {
            if (content.id !== targetId) {
              content.style.display = 'none';
            }
          });

          // Toggle display for clicked item's content
          item.classList.add('selected_list_item');
          targetContent.style.display = (targetContent.style.display === 'none') ? 'block' : 'none';
          if(targetContent.style.display === 'none')
          {
            item.classList.remove('selected_list_item');
          }
        }
      });
    });
  });